import { z } from 'zod';

import { PaginationResponseSchema } from '@/shared/global.schema.tsx';

const ProductSchema = z.object({
    product_variation_id: z.string(),
    name: z.string(),
});

const PurchaseItemSchema = z.object({
    id: z.string(),
    created_at: z.string(),
    updated_at: z.string(),
    purchase_id: z.string(),
    product_variation_id: z.string(),
    quantity: z.number(),
    expiration_date: z.string(),
    purchase_price: z.number(),
    wholesale_price: z.number(),
    retail_price: z.number(),
    product: ProductSchema,
});

// const TransactionSchema = z.object({
//     id: z.string(),
//     created_at: z.string(),
//     updated_at: z.string(),
//     user_id: z.string(),
//     payment_id: z.string(),
//     amount: z.coerce.number(),
//     transaction_type: z.string(),
//     note: z.string().optional().nullable(),
// });

// const PaymentSchema = z.object({
//     id: z.string(),
//     created_at: z.string(),
//     updated_at: z.string(),
//     user_id: z.string(),
//     total_price: z.coerce.number(),
//     total_paid: z.coerce.number(),
//     type: z.string(),
//     status: z.string(),
//     transactions: z.array(TransactionSchema),
// });

// const PurchaseSchema = z.object({
//     id: z.string(),
//     created_at: z.string(),
//     updated_at: z.string(),
//     supplier_id: z.string(),
//     created_by: z.string(),
//     payment_id: z.string(),
//     status: z.string(),
//     note: z.nullable(z.string()),
//     items: z.array(PurchaseItemSchema),
//     payment: PaymentSchema,
//     supplier: z.object({
//         id: z.string(),
//         name: z.string(),
//     }),
// });

export const PurchaseListItemSchema = z.object({
    id: z.string(),
    created_at: z.string(),
    updated_at: z.string(),
    invoice_number: z.string(),
    status: z.string(),
    note: z.string().nullable(),
    supplier_name: z.string(),
    supplier_id: z.string(),
    user_name: z.string(),
    user_id: z.string(),
    payment_status: z.string(),
    total_price: z.coerce.number(),
    paid_amount: z.coerce.number(),
    due_amount: z.coerce.number(),
});

export type PurchaseListItemType = z.infer<typeof PurchaseListItemSchema>;

export const ResponsePurchaseListSchema = z.object({
    data: z.array(PurchaseListItemSchema),
    message: z.string().nullable(),
    pagination: PaginationResponseSchema,
});

export const ResponseSinglePurchaseSchema = z.object({
    data: PurchaseItemSchema,
});
export type PurchaseList = z.infer<typeof ResponsePurchaseListSchema>;
export type SinglePurchase = z.infer<typeof ResponseSinglePurchaseSchema>;
export type PurchaseItem = z.infer<typeof PurchaseItemSchema>;
